import '../../../index.css'
import { LoadingOutlined, SearchOutlined } from '@ant-design/icons'
import { Form, Button, Row, Table, Pagination, Spin, Modal } from 'antd'
import { useEffect, useMemo, useState, useContext } from 'react'
import { convertParamsAxios, convertQueryStringToObject, getSalons, getStaffType } from 'pages/staff/api'
import { setSearchParamsAvatar } from '../stylistSlice'
import FormSearchChange from './FormSearch'
import { SpinIndicator } from 'antd/es/spin'
import { AppContext } from 'layouts/DashboardLayout'
import { Link, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { ParamsSearchType } from 'pages/staff/interface'
import { getListStylistApproval, updateListStylistApproval } from '../api'
import { makeId } from 'utils/helpers'
import { fetchDataByApiKey } from 'pages/staff/hook/fetchViewStaff'
export const antIcon: SpinIndicator = <LoadingOutlined style={{ fontSize: 24 }} spin />
export const STATUS_TYPE = {
  1: 'chưa duyệt',
  2: 'không duyệt',
  3: 'đã duyệt'
}

export default function StylistAvatarComponent() {
  const { notification } = useContext(AppContext)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const dispatch = useAppDispatch()
  const { searchParamsAvatar }: any = useAppSelector((state) => state.stylist)
  const { userInfo }: any = useAppSelector((state) => state.user)
  const [form] = Form.useForm()

  const [data, setData] = useState([])
  const [total, setTotal] = useState(0)
  const [open, setOpen] = useState({ type: null, status: false })
  const [currentStaff, setCurrentStaff] = useState<{
    index?: number
    id?: number
    staffId?: number
    data?: string[]
    statusId?: number
    salon?: string
    fullName?: string
  }>({})

  const [confirmLoading, setConfirmLoading] = useState(false)

  const columns = useMemo(() => {
    return [
      {
        title: 'STT',
        dataIndex: 'index',
        key: 'index'
      },
      {
        title: 'Salon',
        dataIndex: 'salon',
        key: 'salon'
      },
      {
        title: 'Mã nhân viên',
        dataIndex: 'staffId',
        key: 'staffId'
      },
      {
        title: 'Họ và tên',
        dataIndex: 'fullName',
        key: 'fullName'
      },
      {
        title: 'Avatar booking',
        dataIndex: 'data',
        key: 'data',
        render: (item) => (
          <div className='flex justify-center gap-x-2'>
            {item.map((i) => (
              <img key={makeId()} alt='' src={i} className='max-w-[100px] max-h-[100px]' />
            ))}
          </div>
        )
      },
      {
        title: 'Trạng thái',
        dataIndex: 'statusId',
        key: 'statusId',
        render: (statusId) => (
          <div className='flex justify-center'>
            {statusId !== 1 &&
              (statusId === 3 ? (
                <p className='text-[#009F10]'>Đã duyệt</p>
              ) : (
                <p className='text-[#ff4d4f]'>Không duyệt</p>
              ))}
          </div>
        )
      },
      {
        title: 'Hành động',
        key: 'action',
        render: (item) => (
          <div className='flex justify-center gap-x-2'>
            {item.statusId === 1 && userInfo.staffType.id === 9 && (
              <>
                <Button
                  disabled={['đã duyệt', 'không duyệt'].includes(STATUS_TYPE[item.statusId])}
                  onClick={() => {
                    setOpen({ type: true, status: true })
                    setCurrentStaff(item)
                  }}
                  className='border-[#009F10] text-[#009F10]'
                  type='default'
                >
                  Duyệt
                </Button>
                <Button
                  disabled={['đã duyệt', 'không duyệt'].includes(STATUS_TYPE[item.statusId])}
                  onClick={() => {
                    setOpen({ type: false, status: true })
                    setCurrentStaff(item)
                  }}
                  danger
                >
                  Không Duyệt
                </Button>
              </>
            )}
          </div>
        )
      }
    ]
  }, [])

  const handleFetchListStaff = async (paramsSearch: ParamsSearchType) => {
    const payload = { ...paramsSearch }
    if (userInfo.staffType.id === 9) payload.SalonId = userInfo.listSalon[0].id
    try {
      setLoading(true)
      const res: any = await getListStylistApproval(payload)
      setLoading(false)
      if (res.statusCode === 0) {
        setTotal(res.data.totalRecords)
        setData(res.data.listData)
      }
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi! Vui lòng kiểm tra lại')
    }
    setLoading(false)
  }

  const prefetchDataStaffList = () => {
    const paramsSearchResult: any = convertQueryStringToObject(window.location.search.replace('?', ''))
    if (Object.keys(paramsSearchResult).length > 0) {
      dispatch(setSearchParamsAvatar({ ...paramsSearchResult, ...searchParamsAvatar }))
      handleFetchListStaff({ ...paramsSearchResult, ...searchParamsAvatar })
    } else {
      setData([])
    }
  }

  const onFinish = () => {
    navigate(`/stylist/avatar?${convertParamsAxios({ ...searchParamsAvatar, Type: 2, PageIndex: 1 })}`)
  }
  const handleApprove = async () => {
    try {
      setConfirmLoading(true)
      const res: any = await updateListStylistApproval(currentStaff.id, open.type ? 3 : 2)
      notification(
        res.statusCode === 0 ? 'success' : 'error',
        res.statusCode === 0 ? 'Thành công' : 'Thất bại',
        res.statusCode === 0 ? `${open.type ? 'Duyệt' : 'Không duyệt'} thành công` : res.message
      )
      if (res.statusCode === 0) {
        prefetchDataStaffList()
      }
      setConfirmLoading(false)
      setOpen({ ...open, status: false })
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi xảy ra')
      setConfirmLoading(false)
      setOpen({ ...open, status: false })
    }
  }
  useEffect(() => {
    prefetchDataStaffList()
  }, [window.location.search])
  useEffect(() => {
    if (userInfo.staffType.id === 9)
      dispatch(
        setSearchParamsAvatar({
          ...searchParamsAvatar,
          SalonId: userInfo.listSalon.length > 0 ? userInfo.listSalon[0].id : undefined
        })
      )
  }, [userInfo.listSalon])
  const handleFetchData = async () => {
    try {
      await Promise.all([fetchDataByApiKey('salonId', getSalons, dispatch, notification)])
    } catch (error) {
      notification('error', 'Thất bại', 'Có lỗi xảy ra!')
    }
  }
  useEffect(() => {
    handleFetchData()
  }, [])
  return (
    <div className='w-full px-5 py-5 search-wrapper'>
      <Form className='pb-10' form={form} onFinish={onFinish}>
        <div className='text-sm flex gap-x-3 text-[#b7b3b3]'>
          <Link className='hover:text-black' to='#'>
            Duyệt thông tin Stylist
          </Link>
          <span>{`>`}</span>
          <span className='text-black'>Duyệt avatar booking</span>
        </div>
        <h2 className='mb-7 text-2xl'>Duyệt avatar booking</h2>
        <FormSearchChange />
        <div className='bg-white mt-8 ' style={{ padding: '20px 20px 100px 20px' }}>
          <Row className=' flex gap-x-3'>
            <Button
              type='default'
              htmlType='submit'
              className='w-[200px] bg-[#4096ff] text-white hover:bg-white'
              disabled={loading}
            >
              {!loading ? (
                <div className='flex items-center justify-center hover_icon'>
                  <SearchOutlined className='text-white mr-1' />
                  Xem dữ liệu
                </div>
              ) : (
                <Spin indicator={antIcon} />
              )}
            </Button>
          </Row>

          <Row style={{ display: 'contents' }} gutter={18}>
            <div className='flex justify-between items-center'>
              <h3>
                {'Tổng số : '}
                <span className='text-[red] font-semibold'>{total}</span>
              </h3>
              <Pagination
                className='mt-8 pb-8 float-right'
                current={searchParamsAvatar.PageIndex}
                pageSize={searchParamsAvatar.PageSize}
                total={total}
                onChange={(page: number, pageSize: number) => {
                  dispatch(
                    setSearchParamsAvatar({
                      ...searchParamsAvatar,
                      PageSize: pageSize,
                      PageIndex: searchParamsAvatar.PageSize !== pageSize ? 1 : page
                    })
                  )
                  navigate(
                    `/stylist/avatar?${convertParamsAxios({
                      ...searchParamsAvatar,
                      Type: 2,
                      PageSize: pageSize,
                      PageIndex: searchParamsAvatar.PageSize !== pageSize ? 1 : page
                    })}`
                  )
                }}
                showSizeChanger
              />
            </div>
            <Table className='min-w-[1045px] mt-2' dataSource={data} columns={columns} pagination={false} bordered />
            <Pagination
              className='mt-8 pb-8 float-right'
              current={searchParamsAvatar.PageIndex}
              pageSize={searchParamsAvatar.PageSize}
              total={total}
              onChange={(page: number, pageSize: number) => {
                dispatch(
                  setSearchParamsAvatar({
                    ...searchParamsAvatar,
                    PageSize: pageSize,
                    PageIndex: searchParamsAvatar.PageSize !== pageSize ? 1 : page
                  })
                )
                navigate(
                  `/stylist/avatar?${convertParamsAxios({
                    ...searchParamsAvatar,
                    Type: 2,
                    PageSize: pageSize,
                    PageIndex: searchParamsAvatar.PageSize !== pageSize ? 1 : page
                  })}`
                )
                setTimeout(
                  () =>
                    window.document.getElementById('body__page').scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    }),
                  500
                )
              }}
              showSizeChanger
            />
          </Row>
        </div>
      </Form>
      <Modal
        title={open.type ? <p className='text-[#009F10]'>Duyệt</p> : <p className='text-[#ff4d4f]'>Không duyệt</p>}
        open={open.status}
        onOk={handleApprove}
        confirmLoading={confirmLoading}
        onCancel={() => setOpen({ ...open, status: false })}
        okText='Hoàn tất'
        cancelText='Hủy'
      >
        {`Xác nhận ${open.type ? 'duyệt' : 'không duyệt'} ${currentStaff?.fullName || ''} - ${
          currentStaff?.staffId || ''
        }`}
      </Modal>
    </div>
  )
}
